import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const getAuthToken = () => localStorage.getItem('token');

const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getAuthToken()}`,
  },
});

export const getTemplates = async (category = null) => {
  try {
    const params = category ? `?category=${encodeURIComponent(category)}` : '';
    const response = await axios.get(`${API_URL}/sms-templates${params}`, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error fetching templates:', error);
    throw error;
  }
};

export const getTemplate = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/sms-templates/${id}`, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error fetching template:', error);
    throw error;
  }
};

export const createTemplate = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/sms-templates`, data, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error creating template:', error);
    throw error;
  }
};

export const updateTemplate = async (id, data) => {
  try {
    const response = await axios.put(`${API_URL}/sms-templates/${id}`, data, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error updating template:', error);
    throw error;
  }
};

export const deleteTemplate = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/sms-templates/${id}`, getHeaders());
    return response.data;
  } catch (error) {
    console.error('Error deleting template:', error);
    throw error;
  }
};
